import BaseComponent from '@/components/base'
import type { CartAPIEvent } from '@/core/cartAPI'

const classes = {
  hasItems: 'has-items'
}

export default class HeaderCartControl extends BaseComponent {
  static TYPE = 'header-cart-control'
  static MOBILE_MEDIA_QUERY = '(max-width: 63.98rem)'

  currencyFormatter: Intl.NumberFormat
  mobileQuery: MediaQueryList

  onViewportChangeBound: () => void

  constructor(el: HTMLElement) {
    super(el, {
      watchCartUpdate: true,
    })

    this.currencyFormatter = new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })

    this.mobileQuery = window.matchMedia(HeaderCartControl.MOBILE_MEDIA_QUERY)
    this.onViewportChangeBound = this.onViewportChange.bind(this)

    this.mobileQuery.addEventListener('change', this.onViewportChangeBound)
    this.renderFromDataset()
  }

  destroy() {
    this.mobileQuery.removeEventListener('change', this.onViewportChangeBound)

    super.destroy()
  }

  get isMobile() {
    return this.mobileQuery.matches
  }

  formatCartLabel(itemCount: number, totalPriceCents: number) {
    if (this.isMobile) {
      return `Cart: ${itemCount} items`
    }

    const totalPrice = this.currencyFormatter.format(totalPriceCents / 100)

    return `Cart: ${itemCount} items / ${totalPrice}`
  }

  renderCartLabel(itemCount: number, totalPriceCents: number) {
    this.el.textContent = this.formatCartLabel(itemCount, totalPriceCents)
    this.el.classList.toggle(classes.hasItems, itemCount > 0)

    this.el.dataset.itemCount = String(itemCount)
    this.el.dataset.totalPrice = String(totalPriceCents)
  }

  renderFromDataset() {
    const itemCount = Number.parseInt(this.el.dataset.itemCount || '0', 10)
    const totalPrice = Number.parseInt(this.el.dataset.totalPrice || '0', 10)

    this.renderCartLabel(itemCount, totalPrice)
  }

  onViewportChange() {
    this.renderFromDataset()
  }

  onCartUpdate(e: CartAPIEvent) {
    const { cart } = e.detail

    this.renderCartLabel(cart.item_count, cart.total_price)
  }
}